import { User, UserStatus } from 'src/api/generated';

export const getUserStatus = (user: User): UserStatus => {
  if (user.status === UserStatus.CANCELLED) {
    return UserStatus.CANCELLED;
  }

  if (user.status === UserStatus.PENDING_CONFIRMATION) {
    return UserStatus.PENDING_CONFIRMATION;
  }

  return user.deactivatedAt === null ? UserStatus.ACTIVE : UserStatus.INACTIVE;
};

export const isUserActive = (user: User): boolean => {
  return getUserStatus(user) === UserStatus.ACTIVE;
};

export const isUserPending = (user: User): boolean => {
  return getUserStatus(user) === UserStatus.PENDING_CONFIRMATION;
};

export const isUserCancelled = (user: User): boolean => {
  return getUserStatus(user) === UserStatus.CANCELLED;
};
